import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { ApiService } from '../../../../../services/api.service';
import { AppService } from '../../../../../services/app.service';
import { ValidatorService } from '../../../../../services/validator.service';
import { MatDialog } from '@angular/material/dialog';
import { DmCartReservaReprovadoModal } from '../../../modal/dm-cart-reserva-reprovado/dm-cart-reserva-reprovado.component';
import { DmCartPagamentoReprovadoModal } from '../../../modal/dm-cart-pagamento-reprovado/dm-cart-pagamento-reprovado.component';

declare var CardInfo:any; 

@Component({
  selector: 'dm-cart-pagamento-cielo',
  templateUrl: './dm-cart-pagamento-cielo.component.html',
  styleUrls: ['./dm-cart-pagamento-cielo.component.scss']
})
export class DmCartPagamentoCieloComponent implements OnInit {

  @Input("sendPagamento") sendPagamento     = new EventEmitter();
  @Output("onSuccess")  onSuccess           = new EventEmitter();
  @Input("carrinho") carrinho               = null;
  @Input("formaPagamento") formaPagamento   = null;
  @Output("updateResponse")  updateResponse = new EventEmitter();
  @Output("requestEnd") requestEnd          = new EventEmitter();
  @Input("pagamentoData") pagamentoData     = null;
  @Input("requiredEmail") requiredEmail:any = false;

  public dataItem:any                     = {};
  public loader                           = false;
  public message  = "";
  public messageLoader              = "";
  public messageInfo                = {
    show: false,
    data: "",
    class: "",
    title: "Atenção"
  }
  public total = 0;
  public subscribeMessage = null;

  constructor(
    private _api: ApiService,
    private _app: AppService,
    private _modal: MatDialog,
    private validator: ValidatorService
  ){}


   /**
   * 
   * Envia o pagamento
   * 
   */
  send(){

    try{
      
      this.validator.clear();
      this.validator.isEmpty(this.dataItem.cartao.numero_cartao.trim(),"numero_cartao","- Informe o Número do Cartão.");
      this.validator.isEmpty(this.dataItem.cartao.data_validade,"nome_portador","- Informe o Títular do Cartão.");
      this.validator.isEmpty(this.dataItem.cartao.data_validade,"data_validade","- Informe a Validade.");
      this.validator.isEmpty(this.dataItem.cartao.codigo_seguranca,"codigo_seguranca","- Informe o Código de Segurança.");
      this.validator.isEmpty(this.dataItem.cartao.parcelas,"parcelas","- Informe as Parcelas.");

      if(this.requiredEmail == "true" || this.requiredEmail == true){ 
        this.validator.isEmpty(this.dataItem.cartao.email.trim(),"email","- Informe seu E-mail.");
        this.validator.isEmail(this.dataItem.cartao.email.trim(),"email","- E-mail informado é inválido.");
      }

      if(!this.validator.passes()){

        let messages = this.validator.getMessagesHtml();
        this._app.info(messages,"danger")
        this.requestEnd.emit();
        return false;

      }
      if(this.carrinho == null){
        this.finalizarPagafacil();
        return false;
      }
      this.message          = "Finalizando a Reserva. Aguarde!";
      this.loader           = true;
      this.subscribeMessage = null;

      this._api.pagamento().finalizarReserva(this.dataItem).subscribe(response => {

        this.loader = false;
        this.requestEnd.emit();
        let error    = "";

        if(response.status == 1){

          let dataFile = response.data.file;
          let dataPay  = response.data.pay;
          
          this.updateResponse.emit({
            dataFile: dataFile,
            dataPay: dataPay
          });  

          if(dataFile.status == 500){

            this._modal.open(DmCartReservaReprovadoModal,{
              width: "600px",
              data: {
                detalhes: dataFile.data
              }
            });

          }else if(dataPay.status == 500){

            //error  = "Atenção: houve um problema ao gerar o pagamento.<br>";
            //error += dataPay.data; 
            
            //this.subscribeMessage = error;
            this._modal.open(DmCartPagamentoReprovadoModal,{
              width: "600px",
              data: { 
                detalhes: dataPay.data,
                file: dataFile.data
              }
            }); 

          }else{
            this.onSuccess.emit(response);
          }

        }else{

          error = "Atenção";
          error  += response.data; 
          
          this.subscribeMessage  = error; 

        }

      },(response) => {

        this.requestEnd.emit();
        this.loader = false;
        let data    = this._app.formatError(response);
        let error   = "";

        error = data.message;

        this.subscribeMessage = error;

      });

    }catch(e){

      this.requestEnd.emit();
      this.loader = false;

    }

  }
  /**
   * 
   * Finaliza o pagamento do link 
   * 
   */
  finalizarPagafacil(){

    try{

      this._api.pagamento().finalizarPagafacil(this.dataItem).subscribe(response => {

        this.requestEnd.emit();
        this.loader = false;
        let error   = "";

        if(response.status == 1){

          this.onSuccess.emit(response);

        }else{

          error  = "<h4>Atenção: houve um problema ao gerar o pagamento.</h4>";
          error += response.data; 
          
          this.subscribeMessage = error;
          
        }

      },(response) => {

        this.requestEnd.emit();
        this.loader = false;
        let data    = this._app.formatError(response);

        let error   = "<h4>Atenção: houve algo inesperado.</h4>";
        error = data.message;

        this.subscribeMessage = error;

      });

    }catch(e){

      this.loader = false;
      this.requestEnd.emit();

    }

  }
  /**
   * 
   * Seta a bandeira baseado no número do cartão
   * 
   */
  setBrand(){ 
    
    let info = new CardInfo(this.dataItem.cartao.numero_cartao);

    var cardInfo = new CardInfo(this.dataItem.cartao.numero_cartao,{
      brandsLogosPath: "/images/pagamento/brands/",
      brandLogoPolicy: "colored"
    });

    this.dataItem.cartao.brand      = cardInfo.brandAlias; 
    this.dataItem.cartao.brand_logo = cardInfo.brandLogoPng;

  }
  /**
   * 
   * Inicializa o dataItem
   * 
   */
  initDataItem(){

    this.dataItem = {
      pagamento_id: this.formaPagamento.id, 
      apelido: this.formaPagamento.intermediador_apelido, 
      cartao: {
        email: "",
        numero_cartao: "",
        data_validade_mes: "",
        data_validade_ano: "",
        data_validade: "",
        nome_portador: "",
        codigo_seguranca: "",
        brand: null,
        brand_logo: null,
        parcelas: null
      },
      email: "",
      pagafacil: this.pagamentoData
    }

  }
  /**
   * 
   * Change número de parcelas
   * 
   */
  changeValueParcela(parcela){

    this.dataItem.cartao.parcelas = parcela;

  }
  /**
   * 
   * Set Data
   * 
   */
  setData(){

    if(this.carrinho != null){
      this.total = this.carrinho.total;
    }else if(this.pagamentoData != null){
      this.total = this.pagamentoData.valorPagamento;
      this.formaPagamento.numero_max_parcelas = parseInt(this.pagamentoData.quantidadeParcelas);
    }

  }
  /**
   * 
   * Ouvintes
   * 
   */
  onData(){

    this.sendPagamento.subscribe(response => {

      this.send();

    });

  }
  /**
   * 
   * Inicializa as Funções
   * 
   */
  ngOnInit(){
    this.initDataItem();
    this.setData();
    this.onData();
  }


}
